import {Box} from '@mui/material';
import IngestionAnalyticsHeader from './top-panel/IngetionAnalyticsHeader';
import React from 'react';
import IngestionAnalyticsTabs from './tabs-panel/IngestionAnalyticsTabs';

const ViewIngestionAnalytics: React.FC = () => {
  return (
    <Box className="view-ingestion-analytics">
      <IngestionAnalyticsHeader />
      <IngestionAnalyticsTabs />
    </Box>
  );
};
export default ViewIngestionAnalytics;
